export class BooleanDictionaryItem {
  constructor(
    public id: boolean,
    public description: string,
  ) {}
}
